import { client } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { CreateQuoteInput } from "@onsemble/shared";
import { handleClientMethod } from "../client";

// Re-export for convenience
export type { CreateQuoteInput };

export const useCreateQuote = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: CreateQuoteInput) => {
      return await handleClientMethod(
        client.POST("/api/quotes", {
          body: data,
        }),
      );
    },
    onSuccess: (newQuote) => {
      // Invalidate quotes list to refetch
      queryClient.invalidateQueries({ queryKey: ["quotes"] });
      // Optionally set the new quote in cache
      queryClient.setQueryData(["quotes", newQuote.uid], newQuote);
    },
  });
};
